import { z } from "zod";

/**
 * Search params for the Saved Lists account route.
 *
 * `list` is the open list's id, kept in the URL so a list's detail view is
 * linkable and the browser Back button returns to the index instead of leaving
 * the page. Absent means the index. `.catch` for the same reason as the cart's
 * `tab`: a mangled `?list=` is a stale link, not a reason for a route error.
 *
 * Its own module so the schema can be tested without pulling in the page's
 * component graph.
 */
export const savedListsSearchSchema = z.object({
  list: z.string().min(1).optional().catch(undefined)
});
